module.exports = __webpack_public_path__ + "img/3_Dicks_Screen_1_R.925c4ad8.jpg";